import { Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { DateRangePicker } from '@/components/ui/date-range-picker'
import type { DateRangeValue } from '@/components/ui/date-range-picker'
import { FilterFormWrapper } from '@/components/FilterFormWrapper'

export interface KnowledgeFilterValues {
  keySearch: string
  time: DateRangeValue | undefined
}

interface KnowledgeFilterPanelProps {
  values: KnowledgeFilterValues
  onChange: (values: KnowledgeFilterValues) => void
  onSearch: () => void
}

export function KnowledgeFilterPanel({
  values,
  onChange,
  onSearch,
}: KnowledgeFilterPanelProps) {

  return (
    <FilterFormWrapper
      onSearch={onSearch}
      className="rounded-xl border border-solid border-gray-300 bg-white px-6 py-5"
    >
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex min-w-[200px] flex-1 flex-col gap-1">
          <span className="text-sm font-medium">Tên tài liệu</span>
          <Input
            placeholder="Nhập từ khóa"
            value={values.keySearch}
            onChange={(e: { target: { value: any } }) =>
              onChange({ ...values, keySearch: e.target.value })
            }
          />
        </div>

        <div className="flex min-w-[200px] flex-1 flex-col gap-1">
          <span className="text-sm font-medium">Thời gian</span>
          <DateRangePicker
            value={values.time}
            onChange={(v) => onChange({ ...values, time: v })}
            className="w-full"
          />
        </div>

        <Button
          variant="outline"
          size="md"
          className="shrink-0 gap-2 border-[#CE7A58] text-[#CE7A58] hover:bg-[#CE7A58]/10"
          onClick={onSearch}
        >
          <Search size={16} />
          Tìm kiếm
        </Button>
      </div>
    </FilterFormWrapper>
  )
}
